import React from 'react';
import css from './css.module.less';

const ContentGrid = (props) => {
  const { configCols, mainCol } = props;
  return (
    <div className={css.wrapper}>
      {mainCol && <div className={css.mainCol}>{mainCol}</div>}

      <div className={css.row}>
        {(configCols || []).map((i, index) => {
          const { child } = i;
          return (
            <div className={css.col} key={i.key || index}>
              {child}
              {/* <div
                  style={{ background: 'red', width: '100%', height: 900 }}
                /> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ContentGrid;
